import { render, staticRenderFns } from "./SpammersDialog.vue?vue&type=template&id=0a3e0032&scoped=true&"
import script from "./SpammersDialog.vue?vue&type=script&lang=js&"
export * from "./SpammersDialog.vue?vue&type=script&lang=js&"
import style0 from "./SpammersDialog.vue?vue&type=style&index=0&id=0a3e0032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3e0032",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a3e0032')) {
      api.createRecord('0a3e0032', component.options)
    } else {
      api.reload('0a3e0032', component.options)
    }
    module.hot.accept("./SpammersDialog.vue?vue&type=template&id=0a3e0032&scoped=true&", function () {
      api.rerender('0a3e0032', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/leads/SpammersDialog.vue"
export default component.exports